import Card from '@material-ui/core/Card';
import styled from 'styled-components';
import CardContent from '@material-ui/core/CardContent';
import { TextField } from '@material-ui/core';
export const CardContainer = styled(Card)`
  border-radius: 0px !important;
  margintop: 20px !important;
`;
export const CardComponent = styled(Card)`
  display: flex !important;
  flex-direction: row;
  height: 40%;
  width: 100%;
  border: 1px;
  border-radius: 0px !important;
`;
export const CardEntities = styled(Card)`
  border-radius: 0px !important;
  width: 270px;
  padding: 20px 10px;
`;
export const CardOperations = styled(Card)`
  z-index: 1;
  border-radius: 0px !important;
  width: 244px;
  padding: 20px 0px;
`;
export const CardBody = styled(Card)`
  flex: 2;
  padding: 19px 31px 7px 28px;
  box-shadow: none;
`;
export const ActionsCard = styled(Card)`
  box-shadow: none !important;
  height: auto;
`;
export const CardContentList = styled(CardContent)`
  && {
    padding: 0px;
    margin-top: 12px;
    height: auto;
    box-shadow: none;
  }
`;
export const InputTextField = styled(TextField)`
  width: 292px !important;
  box-sizing: border-box !important;
  border: 1px solid #c9d3dc !important;
  background-color: #ffffff !important;

  .MuiOutlinedInput-input {
    padding: 8.5px 14px !important;
  }

  .MuiOutlinedInput-root {
    border-radius: 2px !important;
  }
`;